
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.805 4.029c.26.26.26.682 0 .942L4.943 7.833h7.723a.667.667 0 110 1.334H4.943l2.862 2.862a.667.667 0 11-.943.942l-4-4a.667.667 0 010-.942l4-4c.26-.26.682-.26.943 0z","fill":"#fff"}})])
          )
        }
      }
    